<template>
  <NotificationTypeWrapper :notification="notification">
    <p class="my-0">
      Your
      <a
        :href="actionLink"
        v-text="'discussion reply'"
      />
      was {{ action }}.
    </p>
  </NotificationTypeWrapper>
</template>

<script type="text/babel">
import NotificationTypeMixin from './NotificationTypeMixin'

export default {
  name: 'DiscussionReplyApprovalResponseNotification',
  mixins: [NotificationTypeMixin],
  computed: {
    notificationData() {
      return this.notification.attributes.data
    },
    action() {
      return this.notificationData.reply.status.toLowerCase()
    },
    actionLink() {
      return this.notificationData.reply.link
    },
  },
}
</script>
